import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import DealDetail from "@/pages/DealDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import NewDeal from "@/pages/NewDeal";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import ForTherapists from "@/pages/ForTherapists";
import AdminPanel from "@/pages/AdminPanel";
import TherapistProfile from "@/pages/TherapistProfile";
import DispatchRequestPage from "@/pages/DispatchRequest";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";
import HowItWorks from "@/pages/HowItWorks";
import Faq from "@/pages/Faq";
import OwnerGuide from "@/pages/OwnerGuide";
import EditDeal from "@/pages/EditDeal";

function ProtectedRoute({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-[60vh] flex items-center justify-center text-[#5F6C60]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/deals/:id" element={<DealDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/for-therapists" element={<ForTherapists />} />
            <Route path="/therapists/:id" element={<TherapistProfile />} />
            <Route path="/need-therapist" element={<DispatchRequestPage />} />
            <Route path="/dashboard" element={
              <ProtectedRoute roles={["individual", "business", "admin"]}><Dashboard /></ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute roles={["admin"]}><AdminPanel /></ProtectedRoute>
            } />
            <Route path="/owner-guide" element={
              <ProtectedRoute roles={["admin"]}><OwnerGuide /></ProtectedRoute>
            } />
            <Route path="/dashboard/new" element={
              <ProtectedRoute roles={["individual", "business"]}><NewDeal /></ProtectedRoute>
            } />
            <Route path="/dashboard/edit/:id" element={
              <ProtectedRoute roles={["individual", "business", "admin"]}><EditDeal /></ProtectedRoute>
            } />
            <Route path="/checkout/success" element={
              <ProtectedRoute><CheckoutSuccess /></ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
